import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { Button } from '@mui/material';
import { Login as LoginIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

interface LoginButtonProps {
  variant?: 'text' | 'outlined' | 'contained';
  size?: 'small' | 'medium' | 'large';
  fullWidth?: boolean;
}

const LoginButton: React.FC<LoginButtonProps> = ({ 
  variant = 'contained', 
  size = 'medium',
  fullWidth = false 
}) => {
  const { loginWithRedirect, isAuthenticated, getAccessTokenSilently } = useAuth0();
  const navigate = useNavigate();

  const handleLogin = async () => {
    if (isAuthenticated) {
      navigate('/flow-editor');
      return;
    }
    try {
      // Try to get a token silently
      await getAccessTokenSilently();
      navigate('/flow-editor');
    } catch {
      // If no token, trigger Auth0 login
    await loginWithRedirect({
        appState: { targetUrl: '/flow-editor' },
    });
    }
  };

  return (
    <Button
      variant={variant}
      size={size}
      fullWidth={fullWidth}
      onClick={handleLogin}
      startIcon={<LoginIcon />}
      sx={{
        borderRadius: 2,
        textTransform: 'none',
        fontWeight: 600,
      }}
    >
      Log In / Sign Up
    </Button>
  );
};

export default LoginButton; 